const LOAD_DETAIL_BASIC_ENGLISH           = 'LOAD_DETAIL_BASIC_ENGLISH'
const LOAD_DETAIL_BASIC_ENGLISH_SUCCESS   = 'LOAD_DETAIL_BASIC_ENGLISH_SUCCESS'
const LOAD_DETAIL_BASIC_ENGLISH_FAILED    = 'LOAD_DETAIL_BASIC_ENGLISH_FAILED'
const UNMOUNT_DETAIL_BASIC_ENGLISH        = 'UNMOUNT_DETAIL_BASIC_ENGLISH'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const detailBasicEnglishReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_BASIC_ENGLISH:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_BASIC_ENGLISH_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_BASIC_ENGLISH_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_BASIC_ENGLISH:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default detailBasicEnglishReducer;